import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';

import React from 'react';
import ReactDOM from 'react-dom';
import Promise from 'promise-polyfill';
import { shim } from 'mdn-polyfills/Array.prototype.find';
import findIndex from 'mdn-polyfills/Array.prototype.findIndex';
import values from 'mdn-polyfills/Object.values';
import 'mdn-polyfills/String.prototype.startsWith';
import 'mdn-polyfills/String.prototype.endsWith';
import Root from './main/resources/assets/Root/Root.react';
import Login from './main/resources/assets/Login/Login.react';
import * as serviceWorker from './serviceWorker';

if (!window.Promise) {
	window.Promise = Promise;
}

if (!Array.prototype.find) {
	// Applies a polyfill for Array.prototype.find for the sake of IE
	shim();
}

if (!Array.prototype.findIndex) {
	findIndex.shim();
}

if (!Object.values) {
	values.shim();
}

const rootElement = document.getElementById('root');
if (rootElement !== null) {
	ReactDOM.render(<Root />, rootElement);
}

const loginElement = document.getElementById('login');
if (loginElement !== null) {
	ReactDOM.render(<Login />, loginElement);
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
